import { render, staticRenderFns } from "./ReservationPurposes.vue?vue&type=template&id=34f688f5&scoped=true&"
import script from "./ReservationPurposes.vue?vue&type=script&lang=js&"
export * from "./ReservationPurposes.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPurposes.vue?vue&type=style&index=0&id=34f688f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f688f5",
  null
  
)

export default component.exports